import { useEffect } from 'react';
import logoImage from '../assets/logo.png';

export default function Favicon() {
  useEffect(() => {
    // Remove existing favicon links
    const existingLinks = document.querySelectorAll("link[rel*='icon']");
    existingLinks.forEach(link => link.remove());

    // Create and add new favicon link
    const link = document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/png';
    link.href = logoImage;
    document.head.appendChild(link);

    // Also add apple-touch-icon for better mobile support
    const appleLink = document.createElement('link');
    appleLink.rel = 'apple-touch-icon';
    appleLink.href = logoImage;
    document.head.appendChild(appleLink);
  }, []);

  return null;
}
